var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "form-list-page" } }, [
    _c("h3", { staticClass: "title" }, [
      _vm._v(_vm._s(_vm.$t("message.metaLeadForms"))),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-wrapper" },
      [
        _c("SupsisTable", {
          attrs: {
            columns: _vm.getCols(),
            rows: _vm.forms,
            "top-pagination": "",
            "empty-data-bordered": "",
            "pagination-cursor": _vm.pagination,
            options: {
              rowStyleOption: _vm.rowStyleOption,
              clipboardOption: _vm.clipboardOption,
              fixedHeader: true,
              id: "forms-table",
              borderX: true,
              borderY: true,
            },
          },
          on: {
            "cursor-changed": function (cursor) {
              return (_vm.pagination = cursor)
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }